
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Operation } from '@/types';
import OperationOrderConfirmationDate from '@/components/OperationOrderConfirmationDate.vue';
import OperationTargetDate from '@/components/OperationTargetDate.vue';
import OperationFirstPmClientContactDate from '@/components/OperationFirstPmClientContactDate.vue';

@Component({
  components: {
    OperationOrderConfirmationDate,
    OperationTargetDate,
    OperationFirstPmClientContactDate,
  },
})
export default class OperationUnifiedDates extends Vue {
  @Prop(Object) readonly operation!: Operation;
}
